import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import {HelpersService} from "../../../services/tools/helpers.service";
import { CuentasPorPagarService } from '../../../services/cuentas-por-pagar.service';

@Component({
  selector: 'app-modal-editar-cxp',
  templateUrl: './modal-editar-cxp.component.html',
  styleUrls: ['./modal-editar-cxp.component.scss']
})
export class ModalEditarCXPComponent implements OnInit {

  public modal: any = null;
  public errors: any = {};
  
  //Modelos
  public cuentaPorPagar: any = {};

  //Helpers
  public loading: boolean = null;
  private importeOriginal: number = null;

  @ViewChild('modalEditarCXP') private content: TemplateRef<any>;

  constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
    private modalService: NgbModal,
    private helperService: HelpersService,
    private cxpService: CuentasPorPagarService) { }

  ngOnInit() {
  }

  public openModal(cuentaPorPagar: any){
    this.modal = this.modalService.open(this.content, { });
    this.cuentaPorPagar = cuentaPorPagar;
    this.importeOriginal = cuentaPorPagar.importe;

    this.modal.result.then((data) => {
      this.cuentaPorPagar.importe = this.importeOriginal;
    }, (reason) => {
      this.cuentaPorPagar.importe = this.importeOriginal;
    });
  }

  public closeModal() {
    this.modal.close();
  }

  public actualizarCuenta(){

    this.errors = this.cxpService.validarCuentaPorPagar(this.cuentaPorPagar);
    if (Object.entries(this.errors).length > 0) {
      return false;
    }

    this.cxpService.actualizarCuentaPorPagar(this.cuentaPorPagar).subscribe(
        (response)=>
        {
            const result = response.json().content;
            //Se actualiza el importe de pago pendiente que debe ser el mismo valor al importe, ya que si tuviera pagos parciales no se podría editar
            this.cuentaPorPagar.importe_pendiente_pago = this.cuentaPorPagar.importe;
            //Una vez que se ha actualizado la cuenta, el valor que se guardo es el nuevo importe original. Se requiere porque el close actualiza siempre el valor del importe.
            this.importeOriginal = this.cuentaPorPagar.importe;
            this.modal.close();
            this.helperService.notification('Cuenta actualizada', 'Se ha actualizado exitosamente la cuenta por pagar', 'success');

        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          if(error.status == 400) {
            alert("ERROR: "+JSON.stringify(error));
          }
        }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-cxp/modal-editar-cxp/modal-editar-cxp.component.ts